module.exports = "<h4>Edit Shoes</h4>\n\n<label>New Shoes Name:</label>\n<input [(ngModel)]=\"selectedShoes.name\">\n<br>\n\n<label>New Shoes Price:</label>\n<input [(ngModel)]=\"selectedShoes.price\">\n<br>\n\n<label>New Shoes Size:</label>\n<input [(ngModel)]=\"selectedShoes.size\">\n<br>\n<button class=\"btn btn-info\" (click)=\"beginUpdatingShoes(selectedShoes)\">Update</button>\n<button class=\"btn btn-danger\" (click)=\"beginDeletingShoes(selectedShoes)\">Delete</button>\n"


//////////////////
// WEBPACK FOOTER
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/edit-shoes/edit-shoes.component.html
// module id = ../../../../../src/app/edit-shoes/edit-shoes.component.html
// module chunks = main